module.exports = __webpack_public_path__ + "static/media/maruf.2800d9d8.jpg";